var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLlamadaIcono(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.042,
    height: 20.934,
    viewBox: "0 0 22.042 20.934",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#000;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M17.738,14.416a1.282,1.282,0,0,0-1.58-.023L14.74,15.623c-.165.017-1.114-.051-3.961-2.9l-.47-.47C7.7,9.641,7.413,8.717,7.387,8.5l.946-.945a1.29,1.29,0,0,0,0-1.607L5.511,3.128a1.154,1.154,0,0,0-.8-.278,1.152,1.152,0,0,0-.811.288L.075,7.16l.185.308A48.137,48.137,0,0,0,16.235,22.5l.3.171,4.023-3.822a1.287,1.287,0,0,0,0-1.607Z",
    transform: "translate(0.55 -2.35)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLlamadaIcono);
export default __webpack_public_path__ + "static/media/llamada_icono.95798354973881947c3bf78a2f3c0d69.svg";
export { ForwardRef as ReactComponent };